import { progressApi as api } from "utilities/Axios";
import { getExtractedPath } from "utilities/extractedPath";

const extractedPath = getExtractedPath();

export const getFilesData = (file: any) => {
  const url = file ? `/FileExplorer/Get${extractedPath}?path=${file}` : `/FileExplorer/Get${extractedPath}`;
  return api.get(url);
};

export const uploadFile = (type: string, data: any) => {
  return api.post(`/FileManager/${type}${extractedPath}`, data);
};

export const getFileByUniqueId = (id: string) => {
  return api.get(`/Unity/GetFileRaw${extractedPath}?id=${id}`, { responseType: 'blob' });
};

export const deleteFile = (id: string) => {
  return api.get(`/FileManager/DeleteByFileId${extractedPath}?id=${id}`);
};

export const deleteExplorerFiles = (data: any) => {
  return api.post(`/FileManager/Delete${extractedPath}`, data);
};

export const getFile = (id: string) => {
  return api.get(`/FileManager/file${extractedPath}/${id}`);
};

export const getFiles = (id: string, options = {}) => {
  return api.get(`/FileManager/file${extractedPath}${id}`, { ...options });
};

export const getAllUniqueFiles = (type: string) => {
  return api.get(`/FileManager/GetList${extractedPath}/${type}`);
};

export const uploadImagesForPointClouds = (data: any, options: any = {}) => {
  return api.post(`/FileManager/UploadToExplorer${extractedPath}/raw_drone_image`, data, options);
};

export const uploadVolumesForPointClouds = (data: any, options: any = {}) => {
  return api.post(`/FileManager/UploadToExplorer${extractedPath}/vol_calc_files`, data, options);
};

export const uploadFilesFromGoogleDrive = (link: string, path: string) => {
  return api.post(`/FileManager/UploadToExplorerFromGoogleDrive${extractedPath}/${path}?encodedUrl=${link}`);
};

export const getFileByPath = (data: any) => {
  return api.post(`/FileManager/GetFileByPath${extractedPath}`, data, {
    responseType: 'blob'
  });
};
